import React, { useContext } from 'react';

/* packages */
import Fetch from '../../../util-fetch';
/* packages */

/* stores */
import DeclineStore from './store';
/* stores */

const Index = ({CONFIG, token}) => {
  const orderDeclineContext  = useContext(DeclineStore);
  const orderDeclineMethod = async (orderId) => {
    orderDeclineContext.setLoading(true);
    CONFIG.application.decline.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.decline.api.endpoints.create.url + orderId + "/decline",
      config: {
        method: CONFIG.application.decline.api.endpoints.create.method,
        headers: CONFIG.application.decline.api.headers,
      }
    });
    orderDeclineContext.setStatus(fetch[0]);
    orderDeclineContext.setData(fetch[1]);
    orderDeclineContext.setLoading(false);
  }
  const orderDeclineData = orderDeclineContext.isData();

  return { orderDeclineContext, orderDeclineMethod, orderDeclineData }
}

export default Index;
